var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConfetti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 686,
    height: 181,
    viewBox: "0 0 686 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M656.4 44.85c7.3 9.2 17.2 16.3 29.4 12.8.5-.1-.4-5.2 0-5.3-12.2 3.5-22.1-3.6-29.4-12.8.3.4 0 2.2 0 2.7 0 .4-.3 2.2 0 2.6z",
    fill: "#F7D665"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M663 11.452l8.2-9.8 2 20.1-10.2-10.3z",
    fill: "#0FB8CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M600 31l16.3-19 1 26.1L600 31z",
    fill: "#25DFE8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M593 102.752l-6.1 11.2-6-19.3 12.1 8.1z",
    fill: "#FB639E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M633.5 106.153l5.4-8.7 3.9 15.7-9.3-7z",
    fill: "#0FB8CB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M558.768 97.5s-8.6-11.5-2.7-27.5c3.1 2 7.3 2.2 7.3 2.2s-5.4 18.1 5.1 23.1c-2.2 1.9-9.7 2.2-9.7 2.2z",
    fill: "#F7D665"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M601.599 80.152l-2.2-5.9-6.2.2 4.9-3.8-2.1-5.9 5.1 3.5 4.9-3.9-1.7 6 5.2 3.5-6.2.3-1.7 6z",
    fill: "#FB639E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M235 147.553l3.5-5.1 1.9 9.6-5.4-4.5z",
    fill: "#0FB8CB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M286.3 134.754l3.9 4.7-9.7-.8 5.8-3.9z",
    fill: "#FB639E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M527.4 125.455l-3.9 4.8-1.1-9.7 5 4.9z",
    fill: "#0FB8CB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M438 153.953l-3.5-5 9.6 1.5-6.1 3.5z",
    fill: "#FB639E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M580 106.053l-4.4.4 4.7-5-.3 4.6zM568.97 148.735l-9.918 3.445 1.443 4.156 9.919-3.445-1.444-4.156z",
    fill: "#F7D665"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M498.7 44.25l3 4.7-8.6-1.8 5.6-2.9z",
    fill: "#FB639E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M676.1 89.552l-4 3.9v-8.8l4 4.9z",
    fill: "#0FB8CB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M588.799 49.753l-2.6-4.8 8.4 2.4-5.8 2.4zM628.499 91.95l-2.6-4.9 8.4 2.4-5.8 2.5z",
    fill: "#FB639E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M560.073 41.38l-9.182 2.014.857 3.908 9.182-2.015-.857-3.907z",
    fill: "#F7D665"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M643.55 30.459l-.457 9.389 3.995.194.457-9.389-3.995-.194zM113.199 83.6c4.1-.2 8.3-1.2 10.7-4.5 4.4 1.8 8.8 2.3 13.7 2.2 0 0 2-.1 2.8-.1 4.7-.2 9.1-.9 13.4-3.4 5.6-3.1 9.6-8.5 12.9-13.9-.7 1.1-6.6-1-7.4.2-4.3 7.1-9.9 13.5-18 16.1-.9.3-1.9.5-2.8.7h-.1c-1.3-.1-2.7-.3-4-.8-2.6-.8-5-2.1-7.4-3.3-.5-.3-1.1-.6-1.7-.9.9-3.5-.2-7.5-1.8-10.6-1.6-3-3.3-4.2-6-4.5-1.3-.2-4.7-.3-6.2-.1-.6.1-1.2.2-1.7.5-1.9 1.1-2.2 3.7-1.5 5.6 1.3 3.9 5.7 6.9 9.7 9.1-1 3.3-3.4 6.1-7.5 7.2-.2 0-.3.1-.5.1-1.3-.2-2.6-.7-3.9-1.2-3-1.3-5.5-3.5-7.8-5.9-4.8-5-7.9-11.7-9.6-18.3-1.1-4.3-1.5-9.3-.5-13.9 1.4.3 2.9.5 4.3.5 1.2 0 1.8.1 2.7 0 3.8 0 7.8.3 9.5-3.8 1.2-2.9-.1-6.6-2.6-8.3-1.4-1-3.1-.8-4.6-.8-2.5 0-5.3-.2-7.7.6-2.4.8-4.4 2.6-5.9 4.8-1.4-1.8-2.6-3.8-3.4-5.9-3.8-9.9-.2-22.2 6.6-29.9-.3.3-3.2 0-3.7 0s-3.3-.3-3.7.1c-8.4 9.7-11.6 26.3-2.6 36.6 1.3 1.5 2.8 2.7 4.5 3.6-.5 1.4-.9 2.7-1.1 4-1.1 6.6.7 13.7 3.3 19.8 2.6 6.1 6.8 11.9 12.4 15.6 5.2 3.6 11.2 3 17.2 2.8zm1.8-18.4c-.1-.4 0-.9.1-1.4 1.6 2.1 2.6 4.5 3 6.9-1.6-1.5-2.8-3.4-3.1-5.5zM95.099 33c.6.6 1.2 1.3 1.6 2 1.2 2.2 1.1 5.1-.3 7.2-.5.7-1.1 1.2-1.9 1.6-1.1-.3-2.3-.8-3.3-1.2-.9-.4-1.7-.8-2.5-1.3 1.2-3.4 3.2-6.3 6.4-8.3z",
    fill: "#00D08F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M109.499 61.301c-1.9 1.1-2.2 3.7-1.5 5.6 1.3 3.9 5.7 6.9 9.7 9.1 2.6 1.5 6.1 3 6.1 3 4.2 1.7 8.4 2.2 13.1 2.2.6-.1 1.1-.2 1.6-.3h-.1c-1.3-.1-2.7-.3-4-.8-2.6-.8-5-2.1-7.4-3.3-.5-.3-1.1-.6-1.7-.9-3.5-1.9-7.2-5.2-7.2-5.2-1.6-1.6-2.8-3.5-3.1-5.6-.1-.4 0-.9.1-1.4.2-1.1 1.4-2.3 2.3-3-1.3-.2-4.7-.3-6.2-.1-.6.3-1.2.5-1.7.7zM83.6 65.302c2.6 6.1 6.8 11.9 12.4 15.6 3.1 2 6.3 2.7 9.7 2.9 1.7-.1 3.1-.3 3.9-.4-1.3-.2-2.6-.7-3.8-1.2-3-1.3-5.5-3.5-7.8-5.9-4.8-5-7.9-11.7-9.6-18.3-1.1-4.3-1.5-9.3-.5-13.9.2-.9.2-1 .7-2.7 1.2-3.4 3.2-6.3 6.4-8.3 1.1-.8 2.6-1.2 3.9-1.4h-1.8c-2.5 0-5.3-.2-7.7.6-2.4.8-4.4 2.6-5.9 4.8-1.3 2-2.3 4.5-2.3 4.5-.5 1.4-.9 2.7-1.1 4-.9 6.5.9 13.6 3.5 19.7z",
    fill: "#00B77A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M65.799 106.4s10.2-12.7 29.6-10.8c-1.3 4-.3 8.7-.3 8.7s-21.5-.8-24 12.2c-2.8-1.9-5.3-10.1-5.3-10.1z",
    fill: "#00D08F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9 36.3s-9 1.7-11.2 4.5c5.6 1.6 8.7 6.1 10.3 10.9l9.2-2.5c-3.1-8.3-8.3-12.9-8.3-12.9z",
    fill: "#F7D665"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9 74.3c2 5.8 1.4 12.2 1.4 12.2s4.1-.5 7.5 1c.9-6-.1-11.1-1.6-15.2l-7.3 2z",
    fill: "#10B9BC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M112 55.8l-11-6.5 8.5-4 2.5 10.5z",
    fill: "#FBD45D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M126.399 124.6l-10 8.1 1.9-20.2 8.1 12.1zM24.5 126.398l3.5-5 1.8 9.5-5.3-4.5z",
    fill: "#0FB8CB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8 110.398l3.9 4.7-9.7-.8 5.8-3.9zM296.7 116.297l7.3 9.2-13.1-5.3 5.8-3.9z",
    fill: "#FB639E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M168.865 145.676l-9.629 4.187 1.755 4.035 9.629-4.187-1.755-4.035z",
    fill: "#F7D665"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M486.8 94.3l-3.8 4.8-1.2-9.6 5 4.8z",
    fill: "#0FB8CB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M561.2 123.098l-3.6-5 9.6 1.5-6 3.5z",
    fill: "#FB639E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M511.5 97l-3.5-5 9.6 1.5-6.1 3.5z",
    fill: "#00D08F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M539.5 74.998l-4.5.3 4.8-4.9-.3 4.6zM528.524 117.684l-9.92 3.445 1.444 4.157 9.919-3.445-1.443-4.157z",
    fill: "#F7D665"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M199.5 57.7l3.1-4.5 1.7 8.6-4.8-4.1zM32.6 21.202l-32.5-1.8 1.7 8.6 30.8-6.8z",
    fill: "#0FB8CB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M130.599 37l3.6 4.3-8.8-.8 5.2-3.5zM141.2 93l3.6 4.3-8.8-.8 5.2-3.5zM111.3 8.3l3.5 4.3-8.7-.8 5.2-3.5z",
    fill: "#FB639E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M153.399 78.8l4-.6-3.9 4.7-.1-4.1zM167.486 32.193l-8.62 3.748 1.595 3.668 8.62-3.748-1.595-3.668z",
    fill: "#F7D665"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M61.58 67.255l-3.957.58 1.364 9.301 3.958-.58-1.364-9.3z",
    fill: "#00D08F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M193.699 138.6l3.7-4.1.6 8.7-4.3-4.6zM37.799 76.9l3.6-4.2.7 8.8-4.3-4.6z",
    fill: "#0FB8CB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M231.599 82l3 4.7-8.6-1.8 5.6-2.9zM80.8 81.5l2.9 4.6-8.5-1.7 5.6-2.9zM275.299 116.301l3 4.7-8.6-1.8 5.6-2.9z",
    fill: "#FB639E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M195.038 94.51l-9.002 2.709 1.153 3.83 9.001-2.708-1.152-3.83z",
    fill: "#F7D665"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M74.467 123.939l-3.998.108.254 9.396 3.998-.108-.254-9.396z",
    fill: "#00D08F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M516.299 73.9l-4 3.8V69l4 4.9zM667.099 147.298l-4 3.9v-8.8l4 4.9z",
    fill: "#0FB8CB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M579.799 107.499l-2.6-4.8 8.4 2.4-5.8 2.4zM619.499 149.697l-2.6-4.9 8.4 2.4-5.8 2.5zM451.699 83.697l-2.7-4.9 8.4 2.4-5.7 2.5z",
    fill: "#FB639E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M583.999 77.1l-4-.1 4.7-4-.7 4.1zM551.073 99.126l-9.182 2.015.857 3.907 9.182-2.015-.857-3.907z",
    fill: "#F7D665"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M644.55 63.205l-.457 9.389 3.995.194.457-9.388-3.995-.195z",
    fill: "#00D08F"
  })));
}

export default SvgConfetti;